import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regenerator as _regenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Fragment } from 'react';
import Paragraph from '../Paragraph/index.js';
import Theme from '../../Theme/index.js';
import { Button } from '../Dashboard/Button.js';
import Row from '../../node_modules/reactstrap/esm/Row.js';
import Col from '../../node_modules/reactstrap/esm/Col.js';
import ModalBody from '../../node_modules/reactstrap/esm/ModalBody.js';
import ModalFooter from '../../node_modules/reactstrap/esm/ModalFooter.js';
import styled from 'styled-components';
import PropTypes from 'prop-types';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var Body = styled(ModalBody)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: white;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var Footer = styled(ModalFooter)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  background-color: white;\n  bottom: 0;\n  width: 100vw;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n"])));
var OneTrustFrame = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  .otnotice-menu,\n  .otnotice-menu-mobile,\n  .otnotice-menu-content {\n    display: none;\n  }\n\n  p {\n    text-align: left;\n    font-family: ", ";\n  }\n\n  h2 {\n    color: ", ";\n    font-family: ", ";\n    font-size: 20px;\n  }\n"])), Theme.fonts.Montserrat, Theme.colors.primary, Theme.fonts.PlayfairDisplay);
var Title = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: bold;\n  color: ", ";\n"])), function (props) {
  return props.fontFamily || Theme.fonts.PlayfairDisplay;
}, function (props) {
  return props.mdFont ? "20" : "32";
}, Theme.colors.primary);
var DisabledButton = styled(Button)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: #6c757d !important;\n  opacity: 0.65;\n"])));
var ErrorMessage = styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: red;\n"])));
var ButtonContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var ConsentModal = function ConsentModal(_ref) {
  var data = _ref.data,
    mutation = _ref.mutation,
    history = _ref.history;
  var _React$useState = React__default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isFinishedScrolling = _React$useState2[0],
    setIsFinishedScrolling = _React$useState2[1];
  var _React$useState3 = React__default.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isSubmitting = _React$useState4[0],
    setIsSubmitting = _React$useState4[1];
  var _React$useState5 = React__default.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    hasClickError = _React$useState6[0],
    setHasClickError = _React$useState6[1];
  var _React$useState7 = React__default.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    hasSubmissionError = _React$useState8[0],
    setHasSubmissionError = _React$useState8[1];
  React__default.useEffect(function () {
    window.OneTrust.NoticeApi.Initialized.then(function () {
      window.OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/d026f30a-622a-40b3-b261-d78a6b839240/privacy-notices/e5ba731c-ccde-479b-96cc-c6fd04efc8bb.json"]);
    });
    window.addEventListener("scroll", checkScrollPosition);
    return function () {
      window.removeEventListener("scroll", checkScrollPosition);
    };
  }, []);
  var checkScrollPosition = function checkScrollPosition() {
    var _document$documentEle = document.documentElement,
      scrollTop = _document$documentEle.scrollTop,
      scrollHeight = _document$documentEle.scrollHeight,
      clientHeight = _document$documentEle.clientHeight;
    if (scrollTop + clientHeight >= scrollHeight * 0.8) {
      setIsFinishedScrolling(true);
      setHasClickError(false);
    }
  };
  var handleDisabledClick = function handleDisabledClick() {
    return setHasClickError(true);
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            setIsSubmitting(true);
            _context.n = 1;
            return mutation({
              variables: {
                input: {
                  identifier: data.primaryEmail || data.loginEmail
                }
              }
            });
          case 1:
            history.go(0);
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            setHasSubmissionError(true);
            if (window.rg4js) {
              window.rg4js("send", {
                error: _t,
                tags: ["ConsentModal"]
              });
            }
          case 3:
            _context.p = 3;
            setIsSubmitting(false);
            return _context.f(3);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2, 3, 4]]);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
    "data-testid": "modal-body",
    onScroll: checkScrollPosition
  }, /*#__PURE__*/React__default.createElement(Title, {
    className: "mb-4"
  }, "Our Policies Have Changed"), /*#__PURE__*/React__default.createElement(Paragraph, {
    fw: "normal",
    className: "mb-2"
  }, "To continue, please review the following information:"), /*#__PURE__*/React__default.createElement(Row, {
    className: "mt-2 mb-4"
  }, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(OneTrustFrame, {
    id: "otnotice-e5ba731c-ccde-479b-96cc-c6fd04efc8bb",
    className: "otnotice",
    "data-testid": "frame"
  }))), /*#__PURE__*/React__default.createElement(Footer, null, /*#__PURE__*/React__default.createElement(ButtonContainer, null, hasClickError && !isSubmitting && /*#__PURE__*/React__default.createElement(ErrorMessage, null, "Before clicking \"Agree to Terms of Service\", you must review the policy above."), hasSubmissionError && !hasClickError && !isSubmitting && /*#__PURE__*/React__default.createElement(ErrorMessage, {
    "data-testid": "error-message"
  }, "There was a problem while submitting, please try again later."), !isSubmitting ? isFinishedScrolling ? /*#__PURE__*/React__default.createElement(Button, {
    "data-testid": "enabled-btn",
    onClick: handleSubmit
  }, "Agree to Terms of Service") : /*#__PURE__*/React__default.createElement(DisabledButton, {
    "data-testid": "disabled-btn",
    onClick: handleDisabledClick
  }, " ", "Agree to Terms of Service") : /*#__PURE__*/React__default.createElement(Paragraph, {
    style: {
      fontWeight: "600"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "spinner-border spinner-border-sm",
    "data-testid": "submitting"
  }), " ", "Submitting...")), /*#__PURE__*/React__default.createElement("a", {
    className: "mt-2",
    href: "/logout"
  }, "RETURN TO PUBLIC CONTENT"))));
};
ConsentModal.displayName = "ConsentModal";
ConsentModal.propTypes = {
  data: PropTypes.object,
  mutation: PropTypes.func,
  history: PropTypes.object
};

export { ConsentModal as default };
